import { render, staticRenderFns } from "./wechatuseroff.vue?vue&type=template&id=e4d3fb2c&scoped=true"
import script from "./wechatuseroff.vue?vue&type=script&lang=js"
export * from "./wechatuseroff.vue?vue&type=script&lang=js"
import style0 from "./wechatuseroff.vue?vue&type=style&index=0&id=e4d3fb2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d3fb2c",
  null
  
)

export default component.exports